var render = function render(){var _vm=this,_c=_vm._self._c;return _c('UkrTreasuresPayPalButtonsCreateSection',{attrs:{"PayPalButton":_vm.PayPalButton},on:{"save":_vm.save}})
}
var staticRenderFns = []

export { render, staticRenderFns }